import React, { useState, useEffect } from "react";
import { getContactFormSchema } from "../../../features/odu/components/service";
import { CONTACT_FORM_SCHEMA } from "../../../features/odu/constant/constant";
import { useLanguage } from "../../cache/context/LanguageProvider";
import {
  cdnImage,
  LANGUAGE_PREFIX,
  SOMETHING_WENT_WRONG,
  THANKYOU_NOTE,
} from "../../helper/constants";
import Modal from "../Modal";
import DynamicForm from "../../../features/odu/components/DynamicForm";
import { submitBusinessContactForm } from "../../../features/orp/shared/service";
import ToastMsg from "../../../features/orp/shared/components/ToastMsg/ToastMsg";
import { useLoading } from "../../cache/context/LoadingProvider";

const BusinessContactModal = ({ toggleModalVisibilty }) => {
  const [formSchema, setFormSchema] = useState({});
  const [showContactModal, setShowContactModal] = useState(false);
  const { languagePrefix, selectedLanguage } = useLanguage();
  const [showSucessModal, setShowSucessModal] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const { showLoader, hideLoader } = useLoading();

  useEffect(() => {
    getFormSchema();
  }, [selectedLanguage]);

  const getFormSchema = async () => {
    let url = CONTACT_FORM_SCHEMA.replace(LANGUAGE_PREFIX, languagePrefix);
    let formSchemaResponse = await getContactFormSchema(url);
    setFormSchema(JSON.parse(formSchemaResponse?.data?.packageHtml));
    setShowContactModal(true);
  };

  const showToastMsg = (type, message) => {
    setToastMsg({ type, message });
    setTimeout(() => setToastMsg(null), 10000);
  };

  const handleSubmit = async (formData) => {
    let postData = {
      data: {
        ...formData,
        formType: "business_feedback",
      },
      formType: "business_feedback",
    };
    showLoader();
    let response = await submitBusinessContactForm(postData);
    hideLoader();
    if (response?.data?.statusCode == 200) {
    
      setShowSucessModal(true);
    } else {
      setShowSucessModal(false);
      showToastMsg(
        "Error",
        response?.data?.message || response?.message || SOMETHING_WENT_WRONG
      );
    }
    setShowContactModal(false);
    setTimeout(() => {
      setShowContactModal(false);
      toggleModalVisibilty();
    }, 4000);
  };

  const handleBackButton = () => {
    setShowContactModal(false);
    toggleModalVisibilty();
  };

  return (
    <>
    <div className="business_popup">
      <Modal isOpen={showContactModal}>
          <div className="row">
           
              <div className="colLeft">
                <h3>Contact Us</h3>
                <DynamicForm
                  formSchema={formSchema}
                  handleSubmit={handleSubmit}
                  handleBack={handleBackButton}
                />
            
            </div>
           
              <div className="colRight">
                <img src={`${cdnImage}assets/icons/businessHero.svg`} />
              </div>
            </div>
          
      </Modal> </div>
      <Modal isOpen={showSucessModal}>
        <div className="thankyou thankyou_business">
          <div>
            <img src={`${cdnImage}assets/icons/sucess.svg`} />
            <h4> {THANKYOU_NOTE} </h4>
          </div>
        </div>
      </Modal>
      {toastMsg && (
        <ToastMsg
          message={toastMsg.message}
          type={toastMsg.type}
          onClose={() => setToastMsg(null)}
        ></ToastMsg>
      )}
    </>
  );
};
export default BusinessContactModal;
